import Vue from 'vue';
import { sync } from 'vuex-router-sync';
import App from './App.vue';
import router from './router';
import store from './store';
import eventHub from './scripts/eventHub';
import './registerServiceWorker';
import LoadScript from 'vue-plugin-load-script';
 
window.Vue = Vue;
Vue.use(LoadScript);

Vue.config.productionTip = false;
sync(store, router);

Vue.prototype.$eventHub = eventHub;

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    let userpassword = localStorage.getItem('user-password');
    if( userpassword ) next()
    else next(`/protected${to.fullPath}`);
  } else next()
})

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
